import { useEffect } from 'react';

export const usePrecontractualDocsReset = ({
    onboardingType,
    openDebitCard,
    getPrecontractualDocumentNames,
    formActions,
    setIsReaded,
}) => {
    const resetDocuments = () => {
        formActions.change('userProfile.precontractualDocsOK', false);
        formActions.change('userProfile.saveTimeDocAccept', []);
        formActions.change('userProfile.acceptedText', '');
        formActions.change('userProfile.precontractualDocsId', '');
    };

    useEffect(() => {
        if (onboardingType) {
            getPrecontractualDocumentNames(onboardingType, openDebitCard);
            resetDocuments();
            setIsReaded(false);
        }
    }, [onboardingType]);
};
